// Uncomment here and in export module if OpenApi is present
import { EnvironmentProviders, Provider } from '@angular/core';
import { basePath } from 'src/environments/environment';
import { BASE_PATH, Configuration, ConfigurationParameters } from 'src/openapi-client';

export const OpenApiPathProvider: Provider | EnvironmentProviders = {
  provide: BASE_PATH,
  useValue: basePath,
};

export function apiConfigFactory (): Configuration {
  const params: ConfigurationParameters = {
    withCredentials: true
  }
  return new Configuration(params);
}
